import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "evidencelab.token";

export const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Phase 12 — Credits. A handful of endpoints return HTTP 402 with a
// localised ``message_key`` when the workspace is out of credits.
// We surface a single toast (per session window) so the user knows what
// happened, regardless of which page kicked off the request. Individual
// pages can still inspect the error to render richer modals.
let _last402Ts = 0;
api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const status = err?.response?.status;
    if (status === 402) {
      try {
        const { toast } = require("sonner");
        const i18n = require("@/i18n").default;
        const msg = i18n.t("errors:insufficient_credits", {
          defaultValue: "Not enough credits to continue this run.",
        });
        const now = Date.now();
        if (now - _last402Ts > 4000) {
          toast.error(msg);
          _last402Ts = now;
        }
      } catch (_e) {
        // sonner / i18n not ready — silent
      }
    }
    return Promise.reject(err);
  }
);

/**
 * Normalises a FastAPI / axios error into a plain string suitable for UI display.
 * FastAPI 422 returns an array of { msg } objects; rendering that array crashes React.
 */
export function formatApiError(err, fallback = "Something went wrong.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return (
      detail
        .map((e) => (e && typeof e.msg === "string" ? e.msg : null))
        .filter(Boolean)
        .join(" ") || fallback
    );
  }
  if (typeof detail === "object" && typeof detail.msg === "string") return detail.msg;
  return fallback;
}
